import React from 'react';
import GeckoFieldBase from '../_base';

class GeckoFieldPassword extends GeckoFieldBase {

	attrs() {
		return {
			id             : this.renderId(),
			[`aria-label`] : this.renderAriaLabel(),
			className      : 'col-sm form-control gecko-ui-material',
			type           : 'password',
			disabled       : this.isDisabled(),
			onChange       : this.handleChange.bind(this),
			onBlur         : this.handleBlur.bind(this),
			placeholder    : this.config().placeholder || this.field().placeholder,
			value          : this.value(),
			name: this.name(),
			ref: this.ref(),
			...this.attributes()
		};
	}

	render() {
		return (<input {...this.attrs()} autoComplete="current-password" />);
	}
}

export default GeckoFieldPassword;